import React, { useMemo } from "react";
import { Image, NavDropdown } from 'react-bootstrap';
import { CheckIcon, ElementTooltip, EyeIcon } from '../../components';
import { tooltipConstants } from '../../constants';
import { TimeTrackIcon } from "../../components/icons/TimeTrackIcon";
import DropdownIcon from '../../images/icons/dropdown-arrow.svg';
import { userRoleConstants } from "../../constants";

const renderName =(option, optionname) =>{
  return option.name
}

const handleClick = (event, input, value) => {
  input.onChange(value)
}

export const RoleSelectField = (props) => {
  const {
    input,
    label,
    blank_label,
    exclude_blank_option,
    options, optionname,
    tooltip,
    with_track_icon,
    selectProperText,
    type,
    meta: { touched, error },
    ...rest } = props;
  const selectedOptions = options && options.filter((option) => option.id == input.value)
  const selectedOption = selectedOptions && selectedOptions.length > 0 && selectedOptions[0]

  const renderTooltip = (option) => {
    switch(option?.name.toLowerCase()) {
      case 'team lead':
        return <ElementTooltip
                  tooltip_title={option?.name}
                  tooltip_text={tooltipConstants.ROLE_TEAM_LEAD}
                  id={'select-team_lead'}
                  className={'unselected-tooltip d-flex justify-content-between'}
               >
              </ElementTooltip>

      case 'coordinator':
        return <ElementTooltip
                  tooltip_title={option?.name}
                  tooltip_text={tooltipConstants.ROLE_COORDINATOR}
                  id={'select-coordinator'}
                  className={'unselected-tooltip d-flex justify-content-between'}
               >
              </ElementTooltip>

      case 'production':
        return <ElementTooltip
                  tooltip_title={option?.name}
                  tooltip_text={tooltipConstants.ROLE_PRODUCTION}
                  id={'select-production'}
                  className={'unselected-tooltip d-flex justify-content-between'}
               >
              </ElementTooltip>

      case 'spectator':
        return <ElementTooltip
                  tooltip_title={option?.name}
                  tooltip_text={tooltipConstants.ROLE_SPECTATOR}
                  id={'select-spectator'}
                  className={'unselected-tooltip d-flex justify-content-between'}
               >
              </ElementTooltip>

      case 'approver':
        return <ElementTooltip
                  tooltip_title={option?.name}
                  tooltip_text={tooltipConstants.ROLE_APPROVER}
                  id={'select-approver'}
                  className={'unselected-tooltip d-flex justify-content-between'}
               >
              </ElementTooltip>
      case 'contributor':
        return <ElementTooltip
                  tooltip_title={option?.name}
                  tooltip_text={tooltipConstants.ROLE_CONTRIBUTOR}
                  id={'select-contributor'}
                  className={'unselected-tooltip d-flex justify-content-between'}
               >
              </ElementTooltip>

      default:
        return null
    }
  }

  const guestRoles = React.useMemo(() => 
      options.filter(role => userRoleConstants.GUEST_ROLES.includes(role.name.toUpperCase()))
  ,[options]);

  const teamRoles = React.useMemo(() => 
      options.filter(role => userRoleConstants.TEAM_ROLES.includes(role.name.toUpperCase()))
  ,[options]);

  return (
    <div className="position-relative">
      { label &&
        <label className="mb-1"> {label} </label>
      }

      <NavDropdown 
        {...input} 
        title={ 
          selectedOption ? 
            <> {selectedOption.name} <Image src={DropdownIcon} height={'8'} width={'8'} className="dropdown-icon"/> </> : 
            <>{blank_label} <Image src={DropdownIcon} height={'8'} width={'8'} className="dropdown-icon"/> </>
        } 
        className={ "form-control dropdown--with-check dropdown--with-tooltip detail" + (rest.input_class_name ? " " + rest.input_class_name : "") }
      >
        { !exclude_blank_option &&
          <NavDropdown.Item 
            key="" 
            onClick={(e) => handleClick(e, input, "") }
            className={`${"" == input.value ? 'selected' : '' }`}
          >
            { blank_label }
          </NavDropdown.Item>
        }

        <label>Team Roles</label>

        { teamRoles && teamRoles.map((option, index) => (
            <NavDropdown.Item
              key={option.id}
              onClick={(e) => handleClick(e, input, option.id) }
              className={`d-flex justify-content-between ${option.id === selectedOption?.id ? 'selected' : '' }`}
            >
              <span className={`text-truncate proper-text`}>{ renderName(option, optionname) }</span>

              <div className="d-flex align-items-center justify-content-between">
                
                {
                  tooltip &&
                  renderTooltip(option)
                }
              </div>
            </NavDropdown.Item>
          ))
        }

        <label>Guest Roles</label>


        { guestRoles && guestRoles.map((option, index) => (
            <NavDropdown.Item
              key={option.id}
              onClick={(e) => handleClick(e, input, option.id) }
              className={`d-flex justify-content-between ${option.id === selectedOption?.id ? 'selected' : '' }`}
            >
              <span className={`text-truncate proper-text`}>{ renderName(option, optionname) }</span>

              <div className="d-flex align-items-center justify-content-between">
                
                {
                  tooltip &&
                  renderTooltip(option)
                }
              </div>
            </NavDropdown.Item>
          ))
        }
      </NavDropdown>

      {touched && error && (
      <span className="form-error">{error}</span>
      )}
    </div>
  )
}

export default RoleSelectField
